import { render, staticRenderFns } from "./albumLookShops.vue?vue&type=template&id=475a8778&scoped=true"
import script from "./albumLookShops.vue?vue&type=script&lang=ts"
export * from "./albumLookShops.vue?vue&type=script&lang=ts"
import style0 from "./albumLookShops.vue?vue&type=style&index=0&id=475a8778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475a8778",
  null
  
)

export default component.exports